import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { AnalyticsConsentService } from '../../services/analytics-consent.service';

@Component({
  selector: 'ln-analytics-consent-banner',
  templateUrl: './analytics-consent-banner.component.html',
  styleUrls: ['./analytics-consent-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalyticsConsentBannerComponent {
  private readonly consentService = inject(AnalyticsConsentService);

  readonly visible = computed(() => this.consentService.status() === 'pending');

  accept(): void {
    this.consentService.grant();
  }

  decline(): void {
    this.consentService.deny();
  }
}
